import * as remoteAction from "../remoteAction";
import { getEmailsFromString } from "../../utils/string";
import { PRODUCT_EMAIL_CHANNEL } from "../../constants";

export type EmailShareActionSuccess = remoteAction.MerchantRemoteResponse<
  "EMAIL_SHARE_SUCCESS",
  any
>;
export type EmailShareActionFailure = remoteAction.MerchantRemoteResponse<
  "EMAIL_SHARE_FAILURE",
  any
>;
export type EmailShareActionRequest = remoteAction.MerchantRemoteResponse<
  "EMAIL_SHARE_REQUEST",
  any
>;

export interface EmailShareAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "EMAIL_SHARE_REQUEST";
    success: "EMAIL_SHARE_SUCCESS";
    failure: "EMAIL_SHARE_FAILURE";
  };
}

export interface EmailShareParams {
  merchantId: string;
  recipients: string[] | string;
  message: string;
  campaignId: string;
  email: string;
  // tslint:disable-next-line:no-any
  [otherProps: string]: any;
}

const emailShareRequest = (
  data: EmailShareParams,
  channel: string
): EmailShareAction => {
  if (typeof data.recipients === "string") {
    data.recipients = getEmailsFromString(data.recipients);
  }

  return {
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      request: "EMAIL_SHARE_REQUEST",
      failure: "EMAIL_SHARE_FAILURE",
      success: "EMAIL_SHARE_SUCCESS",
    },
    method: "POST",
    https: true,
    data: { ...data, channel },
    url: "/share/email",
  };
};

export const emailShare = (data: EmailShareParams): EmailShareAction | null =>
  emailShareRequest(data, "email");

/**
 * Email share of one product. Its own channel keeps it apart in reporting and
 * routes its reminder to the product reminder email.
 */
export const productEmailShare = (
  data: EmailShareParams
): EmailShareAction | null => emailShareRequest(data, PRODUCT_EMAIL_CHANNEL);
